module.exports = __webpack_public_path__ + "img/optimizing-dosing.c37ede84.svg";